import { useRef, useEffect, useState } from 'react'
import './SelectionDock.css'

function SelectionDock({ 
  isOpen, 
  selectedCount, 
  onOpenLinks, 
  onCopy, 
  onMoveToSaved, 
  onDelete, 
  onClose 
}) {
  const dockRef = useRef(null)
  const [hasAnimated, setHasAnimated] = useState(false)

  useEffect(() => {
    if (!isOpen) return

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  // Marquer que l'animation a été jouée après la première ouverture
  useEffect(() => {
    if (isOpen && !hasAnimated) {
      // Attendre la fin de l'animation (400ms) avant de marquer comme animé
      const timer = setTimeout(() => {
        setHasAnimated(true)
      }, 400)
      return () => clearTimeout(timer)
    } else if (!isOpen) {
      // Réinitialiser quand le dock est fermé
      setHasAnimated(false)
    }
  }, [isOpen, hasAnimated])

  if (!isOpen || selectedCount === 0) return null

  return (
    <>
      <svg style={{ display: 'none' }}>
        <filter id="glass-distortion-dock">
          <feTurbulence type="turbulence" baseFrequency="0.008" numOctaves="2" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="77" />
        </filter>
      </svg>
      <div 
        ref={dockRef}
        className={`selection-dock glass-container ${hasAnimated ? 'dock-visible' : ''}`}
      >
        <div className="glass-filter"></div>
        <div className="glass-overlay"></div>
        <div className="glass-specular"></div>
        <div className="glass-content">
          <div className="dock-header">
            <span>{selectedCount} sélectionné{selectedCount > 1 ? 's' : ''}</span>
            <button className="dock-close-btn" onClick={onClose}>×</button>
          </div>
          <div className="dock-actions">
            <button 
              className="glass-icon-action"
              onClick={onOpenLinks}
              title="Ouvrir les liens"
            >
              <div className="glass-filter"></div>
              <div className="glass-overlay"></div>
              <div className="glass-specular"></div>
              <div className="glass-content">
                <img src="/Icon chrome.png" alt="Ouvrir" />
              </div>
            </button>
            <button 
              className="glass-icon-action"
              onClick={onCopy}
              title="Copier"
            >
              <div className="glass-filter"></div>
              <div className="glass-overlay"></div>
              <div className="glass-specular"></div>
              <div className="glass-content">
                <img src="/Icon copy.png" alt="Copier" />
              </div>
            </button>
            <button 
              className="glass-icon-action"
              onClick={onMoveToSaved}
              title="Mettre de côté"
            >
              <div className="glass-filter"></div>
              <div className="glass-overlay"></div>
              <div className="glass-specular"></div>
              <div className="glass-content">
                <img src="/Icon inventory.png" alt="Mettre de côté" />
              </div>
            </button>
            <button 
              className="glass-icon-action"
              onClick={onDelete}
              title="Supprimer"
            >
              <div className="glass-filter"></div>
              <div className="glass-overlay"></div>
              <div className="glass-specular"></div>
              <div className="glass-content">
                <img src="/Icon trash.png" alt="Supprimer" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectionDock


